







































import { Vue, Component, Watch } from 'vue-property-decorator';
import _ from 'lodash';

import Header from '@/components/Header.vue';
import NoteCard from '@/components/NoteCard.vue';

import SidebarInst from '../services/sidebar';

import {IHeaderOptions, INote} from '../interfaces';

@Component({
  metaInfo: {
    title: 'Search'
  },
  components: {
    Header,
    NoteCard,
  }
})

export default class Search extends Vue {
  public sidebar = SidebarInst;
  public headerOptions: IHeaderOptions = {
    title: 'Search',
  };

  @Watch('$route', { immediate: true, deep: true })
  routeQueryChanged() {
    this.setSearch();
  }

  mounted() {
    this.setSearch();
  }

  public setSearch() {
    const searchHash = `${this.sidebar.selectedSearch}:${this.sidebar.searchString}`;

    let selectedSearch: string;
    let searchString: any;

    if (this.$route.query.tag) {
      selectedSearch = 'tag';
      searchString = this.$route.query.tag;
    } else if (this.$route.query.project) {
      selectedSearch = 'project';
      searchString = this.$route.query.project;
    } else if (this.$route.query.search) {
      selectedSearch = 'search';
      searchString = this.$route.query.search;
    } else {
      selectedSearch = 'search';
      searchString = '';
    }

    if (searchHash !== `${selectedSearch}:${searchString}`) {
      this.sidebar.selectedSearch = selectedSearch;
      this.sidebar.searchString = searchString;

      this.sidebar.searchNotes();
    }
  }
}
